import { PickingDetails, PickingStatus } from "api/wms/models";
import { InfoLabel } from "components/common/infoLabel";
import { RightPanelSection } from "components/utils/drawer";
import { Typography } from "components/miloDesignSystem/atoms/typography";
import { Button } from "components/miloDesignSystem/atoms/button";
import { MdiPauseCircle } from "components/miloDesignSystem/atoms/icons/MdiPauseCircle";
import { MdiTimer } from "components/miloDesignSystem/atoms/icons/MdiTimer";
import { dateFns } from "utilities";
import { usePickingPatchMutation } from "api/wms/hooks";
import { isAbleToStartBreak } from "pages/wms/shared/utils/isAbleToStartBreak";

interface Props {
  picking: PickingDetails;
}

export const ProgressSection = ({ picking }: Props) => {
  const pauseMutation = usePickingPatchMutation();

  return (
    <RightPanelSection className="mt-3">
      <div className="d-flex align-items-center w-100 gap-2">
        <div className="w-50 borderRight py-3">
          <InfoLabel
            title={
              <Typography fontSize="14" fontWeight="700">
                Postęp
              </Typography>
            }
          >
            <div className="d-flex align-items-center gap-2">
              <Typography fontSize="14" fontWeight="700">
                {picking.progress.total}%
              </Typography>
              {!picking.startedAt && (
                <Typography color="danger600" fontSize="14" fontWeight="600">
                  Picking nierozpoczęty
                </Typography>
              )}
            </div>
          </InfoLabel>
          <InfoLabel title="zeskanowano">
            <Typography fontSize="14" fontWeight="600">
              {picking.progress.onTheWay}%
            </Typography>
          </InfoLabel>
        </div>
        <div className="w-50 pl-3 py-2">
          <InfoLabel
            title={
              <Typography fontSize="14" fontWeight="700">
                Pauza
              </Typography>
            }
          >
            {isAbleToStartBreak(picking.pauseStartedAt, picking.pauseEndedAt) ? (
              <Button
                className="text-uppercase"
                disabled={picking.status === PickingStatus.NOT_STARTED || pauseMutation.isLoading}
                onClick={() =>
                  pauseMutation.mutate({
                    id: picking.id,
                    toUpdate: {
                      pauseStartedAt: dateFns.format(new Date(), "yyyy-MM-dd HH:mm:ss.SSSSSS"),
                      pauseEndedAt: null,
                    },
                  })
                }
                size="small"
                startIcon={MdiPauseCircle}
                variant="gray"
              >
                Rozpocznij
              </Button>
            ) : (
              <Button
                className="text-uppercase"
                disabled={pauseMutation.isLoading}
                onClick={() =>
                  pauseMutation.mutate({
                    id: picking.id,
                    toUpdate: {
                      pauseEndedAt: dateFns.format(new Date(), "yyyy-MM-dd HH:mm:ss.SSSSSS"),
                    },
                  })
                }
                size="small"
                startIcon={MdiTimer}
                variant="gray"
              >
                Wznów pracę
              </Button>
            )}
          </InfoLabel>
          <InfoLabel title="start">
            <Typography fontSize="14" fontWeight="600">
              {picking.pauseStartedAt
                ? dateFns.format(new Date(picking.pauseStartedAt), "H:mm")
                : "---"}
            </Typography>
          </InfoLabel>
          <InfoLabel title="koniec">
            <Typography fontSize="14" fontWeight="600">
              {picking.pauseEndedAt
                ? dateFns.format(new Date(picking.pauseEndedAt), "H:mm")
                : picking.pauseStartedAt
                ? "trwa"
                : "---"}
            </Typography>
          </InfoLabel>
        </div>
      </div>
    </RightPanelSection>
  );
};
